import { useQuery } from "@tanstack/react-query";
import { commercialsDashboard } from "../api/commercialsDashboard";
import { CommercialsDashboardData } from "../types";

export const useCommercialDashboard = () => {

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["commercials-programme-dashboard"],
        queryFn: () => commercialsDashboard.fetch(),
    });

    return {
        data: isSuccess ? data : {} as CommercialsDashboardData,
        isLoading,
        isError,
        error,
    };

};